export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand-mark ${compact ? 'brand-mark--compact' : ''}`}>
      <span className="brand-mark__sigil" aria-hidden="true"><i />法</span>
      <span className="brand-mark__name">HŌ<br />TEI</span>
    </div>
  );
}
